import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/http-services/auth.service';
import { SearchService } from 'src/app/core/http-services/search.service';
import { StatisticsService } from 'src/app/core/http-services/statistics.service';
import { AzureTokenService } from 'src/app/core/services/azure-token.service';
import { SearchResultTableEnum } from 'src/app/shared/enums';
import { SearchResult } from 'src/app/shared/models/search-query.model';
//import { AZURE_OAUTH_URL } from 'src/app/shared/constants';
import { StatisticsResponse } from '../../shared/models/statistics.model';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  firstTabClass: string = "active";
  lastTabClass: string = '';
  public statistics: StatisticsResponse = new StatisticsResponse();
  searchInput: string = "";
  isSearchEntered: boolean = true;
  isInSearchView: boolean = false;
  searchResults: SearchResult[] = new Array();
  searchEnum: SearchResultTableEnum;


  constructor(private router: Router,
    private authService: AuthService,
    private searchService: SearchService,
    private statisticsService: StatisticsService,
    private azureTokenService: AzureTokenService) { }

  ngOnInit(): void {
    this.getStatistics();
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  onTabClicked(tabNo: number) {
  }

  getStatistics() {
    this.statisticsService.getStatistics()
      .subscribe((data: StatisticsResponse) => {
        this.statistics = data;
      });
  }

  executeSearchQuery() {
    if (!this.searchInput) {
      this.isSearchEntered = false;
      return;
    }

    this.isSearchEntered = true;

    this.searchService.getSearchResult(this.searchInput)
      .subscribe((response: SearchResult[]) => {
        this.searchResults = response;
        if (this.searchResults && this.searchResults.length > 0) {
          this.isInSearchView = true;
        }
      });

  }

  loginAzure() {
    if (this.azureTokenService.isLoggedIn()) {
      //USER IS ALREADY LOGGED IN
    }
    else {
      this.azureTokenService.login().then(() => {

      });

      //USER ISN'T LOGGED IN
    }
  }

  typeConversion(val) {
    if (val as SearchResultTableEnum == SearchResultTableEnum.Pharmacy) {
      return "Pharmacy";
    }
    else if (val as SearchResultTableEnum == SearchResultTableEnum.User) {
      return "User";
    }
    else if (val as SearchResultTableEnum == SearchResultTableEnum.AzureAccount) {
      return "Azure Account";
    }
    else if (val as SearchResultTableEnum == SearchResultTableEnum.AzureNamespace) {
      return "Azure Namespace";
    }
    else if (val as SearchResultTableEnum == SearchResultTableEnum.AzureEndpoint) {
      return "Azure Endpoint";
    }
  }

  goToAzureAccount(id) {
    this.router.navigate(['/azureaccounts'], { queryParams: { id: `${id}` } });
  }

  goToAzureNamespace(id) {
    this.router.navigate(['/namespaces'], { queryParams: { id: `${id}` } });
  }

  goToAzureEndpoints(id) {
    this.router.navigate(['/endpoints'], { queryParams: { id: `${id}` } });
  }

  closeSearch() {
    this.isInSearchView = false;
    this.searchInput = '';
  }
}
